module.exports = __webpack_public_path__ + "files/ec4678992f0f78510214501e441a3089.png";